import OrderColumnFilter from './OrderColumnFilter';
import OrderItemStatus from '../../../../Component/UI/OrderItemStatus';
import OrderMemoInput from '../../../../Component/UI/OrderMemoInput';
import OrderAddressText from '../../../../Component/UI/OrderAddressText';
import { linkedOrderRowLayout, OrderRowLayout } from "../../../../Component/orderRowLayout";
import { sellerGiftSourceOrder } from "../../../../Component/sellerGifts";
import { useOrderGiftItems, OrderGiftGridCells } from "../../../../Component/UI/SellerGiftList";
import OrderProductPaymentCells, { productNetAmount } from './OrderProductPaymentCells';
import OrderDeliveryCells from './OrderDeliveryCells';
import BankRefundCell from './BankRefundCell';
import OrderPaymentCells from './OrderPaymentCells';
import React, { memo, useState } from "react";

import { Order_detail, OrderList, OrderListprops } from "../../../../Component/Interface/Order";

import { CheckBox } from "../../../../Component/style/common_style";

import {

  OrderCell,

  OrderHeaderCell,

  OrderTable,

  OrderTableHeader,

  RenderOrderCells,

} from "../../../../Component/style/orderTable_style2";

import styled from "styled-components";

import ExcessOrderItemModal from "../Modal/ExcessOrderItemModal";



// 헤더/바디가 같은 컬럼 순서·너비를 공유해야 정렬이 안 어긋난다 — 이 배열이 유일한 기준(SSOT).

// 취소수량 컬럼은 cancelMode일 때만 존재하므로 DOM(RenderOrderCells 유무)과 함께 항상 같이 넣고 뺀다.

const buildGridColumns = (showTracking: boolean, cancelMode?: boolean, showCashReceipt = false) =>
  [

    "4rem", // 체크박스

    "8rem", // 주문번호
    "8rem", // 주문상세번호
    "10rem", // 주문일시
    "10rem", // 상태변경일
    "12rem", // 처리 상태
    ...(showTracking ? ["10rem"] : []), // 택배 상태
    "8rem", // 주문자

    "10rem", // 입금자

    "8rem", // 상품코드

    "minmax(28rem, 3fr)", // 품목명

    "minmax(10rem, 1fr)", // 옵션

    "minmax(8rem, 1fr)", // 단가

    "6rem", // 수량

    ...(cancelMode ? ["8rem"] : []), // 취소 수량

    "8rem", // 할인 금액
    "minmax(10rem, 1fr)", // 총 금액

    "6rem", // 택배비

    "minmax(10rem, 1fr)", // 총 결제금액

    "12rem", "13rem", "12rem", "13rem", // PG/무통장 금액과 확인일시
    ...(showCashReceipt ? ["10rem"] : []), // 배송완료 주문의 현금영수증 발행 여부
    "20rem", // 무통장 환불
    "8rem", // 받는 분

    "12rem", // 받는 분 전화

    "7rem", // 받는 분 우편번호

    "minmax(20rem, 2fr)", // 받는 분 주소

    "minmax(16rem, 1.8fr)", // 배송시 요청사항

    ...(showTracking ? ["8rem", "12rem"] : []), // 택배사, 송장번호
    "minmax(14rem, 4fr)", // 메모

  ].join(" ");

const cashReceiptLabel = (order: OrderList) => {
  if (order.bank_cash_receipt_issued === true) return '발행';
  if (order.bank_cash_receipt_issued === false) return '미발행';
  const summary = order.payment_summary;
  const hasBank = ['bank', 'combined'].includes(summary?.payment_mode || '') || Number(summary?.bank_amount) > 0
    || order.order_details.some(detail => detail.payment_method === 'bank');
  const pgOnly = summary?.payment_mode === 'pg' || order.order_details.length > 0 && order.order_details.every(detail => detail.payment_method === 'pg');
  return !hasBank && pgOnly ? '해당 없음' : '확인 필요';
};


const Order_paydeil = memo(

  ({

    list,

    total,

    selectOrder,

    setSelectOrder,

    modify_memo,

    select_status,

    setSelect_status,

    page,

    liveInfo,

    cancelMode,

    cancelQtyMap,

    onChangeCancelQty,

    cancelDeliveryMap,

    onToggleCancelDelivery,

    isAllCancelDeliveryChecked,

    onSetAllCancelDelivery,

    onRequestRemoveFromCancel,

    fullOrderList,

  onBankRefund,
  }: OrderListprops) => {

    const setting_check_list = (seq: number) => {

      // 취소 리뷰 모드에선 체크 해제 = "환불 리스트에서 빼기"라 바로 안 지우고 확인 모달을 띄운다.

      if (cancelMode) {

        onRequestRemoveFromCancel?.(seq);

        return;

      }

      if (select_status !== "") {

        if (

          !window.confirm("모든 주문 선택이 취소됩니다.\n취소하시겠습니까?")

        ) {

          return;

        }

        if (setSelect_status) setSelect_status("");

        return;

      }



      if (!selectOrder || !setSelectOrder) {

        return;

      }

      const copyArr = selectOrder.includes(seq)

        ? selectOrder.filter((item) => item !== seq)

        : [...selectOrder, seq];

      setSelectOrder(copyArr);

    };



    const all_check = () => {

      // 취소 리뷰 모드에선 전체선택 해제가 개별 확인 모달 없이 한 번에 다 빠지게 돼 위험하다 — 막는다.

      if (cancelMode) return;

      if (select_status !== "" && setSelect_status) return setSelect_status("");

      if (!setSelectOrder || !selectOrder) return;



      const allDetailSeqs = list.flatMap((order) =>

        order.order_details.map((detail) => detail.detail_seq)

      );



      if (isChecked_all()) {

        setSelectOrder([]);

      } else {

        setSelectOrder(allDetailSeqs);

      }

    };



    const isChecked_all = () => {

      if (select_status !== "") return true;

      if (!selectOrder || selectOrder.length === 0) return false;

      const allDetailSeqs = list.flatMap((order) =>

        order.order_details.map((detail) => detail.detail_seq)

      );

      return allDetailSeqs.length > 0 && allDetailSeqs.every((seq) => selectOrder.includes(seq));

    };

    const isChecked_item = (detail_seq: number) => {

      if (select_status !== "") return true;

      if (selectOrder?.includes(detail_seq)) return true;

      return false;

    };



    // 초과 주문건(재고 초과) 단건 팝업 — 수량 칸의 빨간 ! 아이콘 클릭 시

    const [excessDetail, setExcessDetail] = useState<Order_detail | null>(null);

    const handleExcessModal = () => setExcessDetail(null);

    const findDetail = (detail_seq: number) =>

      list

        .flatMap((order) => order.order_details)

        .find((d) => d.detail_seq === detail_seq) ?? null;



    const showTracking = !["payment-wait", "payment-done"].includes(page);
    const showCashReceipt = page === 'delivery-done';
    const cashReceiptColumn = 22 + (showTracking ? 1 : 0) + (cancelMode ? 1 : 0);
    const giftItems = useOrderGiftItems();
  const GRID_COLUMNS = buildGridColumns(showTracking, cancelMode, showCashReceipt);
    const minWidth = (cancelMode ? 349 : 341) - (showTracking ? 0 : 30) + (showCashReceipt ? 10 : 0);


    return (

      <>

        <OrderTableHeader $columns={GRID_COLUMNS} $minWidth={minWidth}>
          <OrderHeaderCell>

            <CheckBox

              type={"checkbox"}

              className="red"

              onChange={all_check}

              checked={isChecked_all()}

            />

          </OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>주문번호</OrderColumnFilter></OrderHeaderCell><OrderHeaderCell><OrderColumnFilter>주문상세번호</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>주문일시</OrderColumnFilter></OrderHeaderCell>
          <OrderHeaderCell><OrderColumnFilter>상태변경일</OrderColumnFilter></OrderHeaderCell>
          <OrderHeaderCell><OrderColumnFilter>처리 상태</OrderColumnFilter></OrderHeaderCell>
          {showTracking && <OrderHeaderCell><OrderColumnFilter>택배 상태</OrderColumnFilter></OrderHeaderCell>}
          <OrderHeaderCell><OrderColumnFilter>주문자</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>입금자</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>상품코드</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>품목명</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>옵션</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>단가</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>수량</OrderColumnFilter></OrderHeaderCell>

          {cancelMode && <OrderHeaderCell>취소 수량</OrderHeaderCell>}

          <OrderHeaderCell><OrderColumnFilter>할인 금액</OrderColumnFilter></OrderHeaderCell>
          <OrderHeaderCell><OrderColumnFilter>총 금액</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell>

            <OrderColumnFilter>택배비</OrderColumnFilter>

            {cancelMode && (

              <CheckBox

                type={"checkbox"}

                className="red"

                style={{ marginLeft: 4 }}

                checked={isAllCancelDeliveryChecked ?? false}

                onChange={() =>

                  onSetAllCancelDelivery?.(!isAllCancelDeliveryChecked)

                }

              />

            )}

          </OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>총 결제금액</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>PG 결제금액</OrderColumnFilter></OrderHeaderCell><OrderHeaderCell><OrderColumnFilter>PG 결제일시</OrderColumnFilter></OrderHeaderCell>
          <OrderHeaderCell><OrderColumnFilter>무통장 입금액</OrderColumnFilter></OrderHeaderCell><OrderHeaderCell><OrderColumnFilter>무통장 입금 확인일시</OrderColumnFilter></OrderHeaderCell>
          {showCashReceipt && <OrderHeaderCell><OrderColumnFilter>현금영수증</OrderColumnFilter></OrderHeaderCell>}
          <OrderHeaderCell><OrderColumnFilter>무통장 환불</OrderColumnFilter></OrderHeaderCell>
          <OrderHeaderCell><OrderColumnFilter>받는 분</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>받는 분 전화</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>받는 분 우편번호</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>받는 분 주소</OrderColumnFilter></OrderHeaderCell>

          <OrderHeaderCell><OrderColumnFilter>배송시 요청사항</OrderColumnFilter></OrderHeaderCell>

          {showTracking && <>
            <OrderHeaderCell><OrderColumnFilter>택배사</OrderColumnFilter></OrderHeaderCell>
            <OrderHeaderCell><OrderColumnFilter>송장번호</OrderColumnFilter></OrderHeaderCell>
          </>}
          <OrderHeaderCell className="last"><OrderColumnFilter>메모</OrderColumnFilter></OrderHeaderCell>

        </OrderTableHeader>



        {list.map((data, idx) => {

          const gifts = giftItems.filter(gift => sellerGiftSourceOrder(gift) === data.seq
            && (gift.source_product_seq == null || data.order_details.some(detail => Number(detail.product_seq) === Number(gift.source_product_seq))));
          const layout = linkedOrderRowLayout(data.order_details, gifts);
          const rowHeight = layout.rowCount;

          // 취소수량/택배비 체크를 반영한 재계산. cancelMode에선 data.order_details가 체크된

          // 것만 남은 상태라, fullOrderList에서 원본을 찾아 체크 안 된 형제 품목(안 건드리는

          // 상품)은 원금액 그대로, 체크된 품목만 (수량-취소수량)으로 남는 금액을 합산한다.

          const fullOrder = fullOrderList?.find((o) => o.seq === data.seq);

          const selectedSeqs = new Set(data.order_details.map((d) => d.detail_seq));

          const cancelTotalPayment =

            (fullOrder?.order_details ?? data.order_details).reduce((sum, d) => {

              if (selectedSeqs.has(d.detail_seq)) {

                const cancelQty = cancelQtyMap?.[d.detail_seq] ?? d.order_cnt;

                return sum + productNetAmount(d, cancelQty);
              }

              return sum + productNetAmount(d);
            }, 0) + ((cancelDeliveryMap?.[data.seq] ?? true) ? 0 : data.delivery_price);

          const total_payment = cancelMode

            ? cancelTotalPayment.toLocaleString("ko-KR")

            : (data.payment_summary ? data.payment_summary.pg_amount + data.payment_summary.bank_amount : Number(data.total_payment) + Number(data.delivery_price || 0)).toLocaleString("ko-KR");
          // 취소수량/택배비를 제외한 나머지 열은 리뷰 모드일 때 비활성화된 느낌으로 회색 처리.

          const dim = cancelMode ? ({ color: "var(--admin-theme-muted, #716a7c)" } as React.CSSProperties) : undefined;


          return (

            <OrderRowLayout.Provider key={data.seq} value={layout}><OrderTable aria-label={`주문 ${data.seq}`}

              key={data.seq}

              className={idx % 2 === 0 ? "" : "x2"}

              $columns={GRID_COLUMNS}

              $minWidth={minWidth}
              $height={rowHeight}

            >

              <OrderGiftGridCells items={gifts} firstRow={(data.order_details.length || 1) + 1} columns={Object.fromEntries(Object.entries({
                1: 'blank', 3: 'number', 4: 'date', 5: 'blank', 6: 'status', 9: 'product', 10: 'name', 11: 'option', 12: 'amount', 13: 'quantity',
                14: 'amount', 15: 'amount', 23: 'recipient', 24: 'phone', 25: 'postcode', 26: 'address', 28: 'memo',
              }).map(([col, value]) => [Number(col) + (showTracking && Number(col) >= 7 ? (Number(col) === 28 ? 3 : 1) : 0), value])
                .concat(showTracking ? [[7, 'blank'], [29, 'blank'], [30, 'blank']] : []).map(([col,value])=>[Number(col)+(cancelMode && Number(col)>=(showTracking ? 15 : 14)?1:0),value]).concat(cancelMode ? [[showTracking ? 15 : 14, 'blank']] : [])
                .map(([col,value])=>[Number(col)+(showCashReceipt && Number(col)>=cashReceiptColumn?1:0),value])) as any} />
              <RenderOrderCells

                detailData={data.order_details}

                searchkey={"seq_check"}

                renderCell={(detail_seq) => (

                  <CheckBox

                    type={"checkbox"}

                    className="red"

                    value={detail_seq}

                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>

                      setting_check_list(Number(e.target.value))

                    }

                    checked={isChecked_item(detail_seq)}

                  />

                )}

              />



              <OrderCell style={dim}>{data.seq}</OrderCell><RenderOrderCells detailData={data.order_details} searchkey="seq_check" cellStyle={dim} renderCell={seq => seq} />
              <RenderOrderCells
                detailData={data.order_details}
                searchkey={"주문일시"}
                cellStyle={dim}
              />
              <RenderOrderCells
                detailData={data.order_details}
                searchkey={"상태변경일"}
                cellStyle={dim}
              />
              <RenderOrderCells detailData={data.order_details} searchkey="seq_check" cellStyle={dim} renderCell={seq => {
                const detail = data.order_details.find(item => item.detail_seq === seq);
                return <OrderItemStatus detailSeq={seq} status={detail?.order_status || ''} claims={data.claims} cancellations={data.claim_cancellations} quantity={detail?.order_cnt} />;
              }} />
              {showTracking && <RenderOrderCells detailData={data.order_details} searchkey="택배 상태" cellStyle={dim} />}


              <OrderCell style={dim}><OrderAddressText address={data.order_name + (data.buyer_withdrawn ? " (탈퇴 회원)" : "")} /></OrderCell>
              <OrderCell style={dim}><OrderAddressText address={data.order_nickname || "-"} /></OrderCell>



              {["상품코드", "품목명", "옵션", "단가"].map((key) => (

                <RenderOrderCells

                  key={key}

                  detailData={data.order_details}

                  searchkey={key}

                  cellStyle={dim}

                />

              ))}



              <RenderOrderCells

                detailData={data.order_details}

                searchkey={"수량_초과표시"}

                cellStyle={dim}

                renderCell={(detail_seq) => {

                  const detail = findDetail(detail_seq);

                  const excessQty = detail?.excess_qty ?? 0;

                  if (excessQty <= 0) return detail?.order_cnt;

                  return (

                    <ExcessQtyBtn onClick={() => setExcessDetail(detail)}>

                      {detail?.order_cnt}

                      <span className="excess">({excessQty})</span>

                      <span className="mark">!</span>

                    </ExcessQtyBtn>

                  );

                }}

              />



              {cancelMode && (

                <RenderOrderCells

                  detailData={data.order_details}

                  searchkey={"취소수량_스테퍼"}

                  renderCell={(detail_seq) => {

                    const detail = findDetail(detail_seq);

                    const max = detail?.order_cnt ?? 1;

                    const qty = cancelQtyMap?.[detail_seq] ?? max;

                    const changed = qty !== max;

                    return (

                      <CancelQtyStepper>

                        <button

                          type="button"

                          onClick={() => onChangeCancelQty?.(detail_seq, qty - 1)}

                        >

                          −

                        </button>

                        <div className={changed ? "changed" : ""}>{qty}</div>

                        <button

                          type="button"

                          onClick={() => onChangeCancelQty?.(detail_seq, qty + 1)}

                        >

                          +

                        </button>

                      </CancelQtyStepper>

                    );

                  }}

                />

              )}



              <OrderProductPaymentCells details={data.order_details} cancelQtyMap={cancelMode ? cancelQtyMap || {} : undefined} style={dim} />


              <OrderCell>

                {cancelMode ? (

                  <CancelDeliveryCell>

                    {data.delivery_price}

                    <CheckBox                      aria-label={`주문 ${data.seq} 배송비 취소`}

                      type={"checkbox"}

                      className="red"

                      checked={cancelDeliveryMap?.[data.seq] ?? true}

                      onChange={() => onToggleCancelDelivery?.(data.seq)}

                    />

                  </CancelDeliveryCell>

                ) : (

                  <div>{data.delivery_price}</div>

                )}

              </OrderCell>

              <OrderCell style={dim}>{total_payment}</OrderCell>

              <OrderPaymentCells summary={data.payment_summary} order={data} />
              {showCashReceipt && <OrderCell aria-label={`주문 ${data.seq} 현금영수증`}>{cashReceiptLabel(data)}</OrderCell>}
              <BankRefundCell order={data} onRefund={onBankRefund} />
              <OrderDeliveryCells order={data} style={dim} />
              <OrderCell style={dim}><OrderAddressText address={data.request_memo || data.order_inquiry || "-"} /></OrderCell>


              {showTracking && <>
                <RenderOrderCells
                  detailData={data.order_details}
                  searchkey={"택배사"}
                  cellStyle={dim}
                />


                <RenderOrderCells
                  detailData={data.order_details}
                  searchkey={"송장번호"}
                  cellStyle={dim}
                />
              </>}


              <RenderOrderCells

                detailData={data.order_details}

                searchkey={"seq_check"}

                className="last"

                cellStyle={dim}

                renderCell={(detail_seq) => {

                  const currentMemo =

                    data.order_details.find((d) => d.detail_seq === detail_seq)

                      ?.admin_memo || "";

                  return (

                    <OrderMemoInput memo={currentMemo} disabled={cancelMode} onCommit={nextMemo => modify_memo?.(detail_seq, "admin_memo", nextMemo)} />

                  );

                }}

              />



            </OrderTable></OrderRowLayout.Provider>

          );

        })}



        <ExcessOrderItemModal

          visible={excessDetail !== null}

          handleModal={handleExcessModal}

          liveInfo={liveInfo}

          excessQty={excessDetail?.excess_qty ?? 0}

        />

      </>

    );

  }

);



export default Order_paydeil;



const CancelQtyStepper = styled.div`

  display: inline-flex !important;

  align-items: center !important;

  gap: 4px;

  border: none !important;

  button {

    width: 20px !important;

    height: 20px !important;

    flex: none !important;

    border: 1px solid var(--admin-theme-border, #e0e0e0) !important;
    border-radius: 4px;

    background: var(--admin-theme-surface, white);
    color: var(--admin-ink);
    cursor: pointer;

    line-height: 1;

    padding: 0;

  }

  div {

    width: auto !important;

    min-width: 18px;

    flex: none !important;

    border-bottom: none !important;

    text-align: center;

    font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
  }

  div.changed {

    color: var(--admin-theme-danger, #eb003b);
    font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  }

`;



const CancelDeliveryCell = styled.div`

  display: flex;

  align-items: center;

  justify-content: center;

  gap: 6px;

`;



const ExcessQtyBtn = styled.div`

  display: inline-flex;

  align-items: center;

  cursor: pointer;

  border: none !important;

  span.excess {

    color: var(--admin-theme-danger, #eb003b);
    width: auto;

    border: none !important;

    font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  }

  span.mark {

    display: inline-flex;

    align-items: center;

    justify-content: center;

    width: 13px;

    height: 13px;

    margin-left: 4px;

    border-radius: 50%;

    background-color: #eb003b;

    color: white;

    font-size: 9px;

    font-family: var(--font-family-base); font-weight: var(--font-weight-bold);
    flex-shrink: 0;

  }

`;



const MatchingBtn = styled.div.withConfig({

  shouldForwardProp: (prop) => prop !== "matching",

}) <{ matching: boolean }>`

  width: 62px;

  height: 30px;

  display: flex;

  align-items: center;

  justify-content: center;

  background: ${(props) =>

    props.matching ? "linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep))" : "var(--admin-theme-raised, #F0F0F0)"};
  cursor: pointer;

  border-radius: 8px;

  color: ${(props) => (props.matching ? "white" : "var(--admin-theme-muted, #C6C6C6)")};
  font-size: 12px;

  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
`;



const PayDoneBtn = styled.div`

  width: 62px;

  height: 30px;

  display: flex;

  align-items: center;

  justify-content: center;

  background: var(--admin-theme-accent-soft, #ecf1ff);
  cursor: pointer;

  border-radius: 8px;

  color: var(--admin-theme-link, #2768ff);
  font-size: 12px;

  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
`;




